import React, { useState, useRef } from "react";
import { navigate } from "@reach/router";
import labels from "../../../../helpers/labels.json";
import { PrimaryCTAButton } from "../../../common/Buttons";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import COLORS from "../../../../assets/Colors";
import theme from "../../../../assets/theme";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SystemService from "../../../../services/SystemService";
import { Bold } from "../../../pages/ProfileDetails/styles";
import { TableWrapper } from "../../PaymentHistory/Styles";
import queryString from "query-string";
import CustomTable from "../../../common/CustomTable/CustomTable";
import { getErrorMessage } from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import _ from "lodash";
import useLoader from "../../../../hooks/useLoader";

async function fetchWebinarConfigs(query, status) {
  try {
    const response = await SystemService.fetchWebinarConfigs(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const ArbitratorsInfo = ({
  systemConfig,
  StyleCard,
  link,
  label,
  customTable,
}) => {
  const useStyles = makeStyles((themes) => ({
    root1: {
      width: "100%",
      backgroundColor: "white",
      boxShadow: "none",
    },
    secondaryHeading: {
      maxWidth: "960px",
      width: "100%",
      fontFamily: theme.fonts.primaryFontRegular,
      fontSize: "14px",
      color: COLORS.COLOR_DARK,
      lineHeight: "1.57",
    },
  }));
  const MTRef = useRef();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({});
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  async function deleteWebinarConfig(id) {
    try {
      setLoader({ state: true, message: "Delete webinar..." });
      const response = await SystemService.deleteWebinarConfig(id);
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      MTRef.current.onQueryChange("");
    }
  }

  const columns = [
    {
      field: "id",
      title: "Webinar ID",
      sorting: true,
      render: (rowData) => rowData?.id,
      headerStyle: {
        width: 120,
      },
    },
    {
      field: "status",
      title: "Status",
      render: (rowData) => (
        <Bold
          onClick={() =>
            navigate(`/dashboard/configurations/${link}/${rowData?.id}`)
          }
        >
          {rowData.status}
        </Bold>
      ),
      sorting: false,
      headerStyle: {
        width: 150,
      },
    },
    {
      field: "created_at",
      title: "Created On",
      headerStyle: {
        width: 150,
      },
      render: (rowData) => rowData?.created_at,
    },
    {
      field: "updated_at",
      title: "Updated On",
      headerStyle: {
        width: 150,
      },
      render: (rowData) => rowData?.updated_at,
    },
    {
      field: "actions",
      title: "Action",
      sorting: false,
      headerStyle: { textAlign: "center", width: "20%" },
      cellStyle: { padding: "12px 16px", textAlign: "center" },
      render: (rowData) => (
        <DeleteButtonContainer onClick={() => deleteWebinarConfig(rowData.id)}>
          <DeleteIcon>✕</DeleteIcon>
        </DeleteButtonContainer>
      ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";

      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      fetchWebinarConfigs(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <CardWrapper style={StyleCard}>
      <Accordion expanded={open} className={classes.root1}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={() => setOpen(!open)} />}
        >
          <div className="heading">
            <FlexBetween>
              <CardHeader>
                {label === "arbitartors" ? labels.arbitartors : "Webinar"}
              </CardHeader>
              <WrapperButton>
                <PrimaryCTAButton
                  onClick={() => navigate(`/dashboard/configurations/${link}`)}
                  style={{ padding: "unset", height: 35 }}
                >
                  {labels.update}
                </PrimaryCTAButton>
              </WrapperButton>
            </FlexBetween>
          </div>
        </AccordionSummary>
        {customTable && (
          <AccordionDetails>
            <TableWrapper>
              <CustomTable
                hidePagination={state.lastPage === 1}
                pageSize={state?.data?.length ? state?.data?.length : 10}
                pluralTitle={"Webinar"}
                singularTitle=""
                {...{
                  columns,
                  data,
                  MTRef,
                }}
                placeholderText="search webinar"
                //noToolbar
                hideFilterBar
                state={state}
              />
            </TableWrapper>
          </AccordionDetails>
        )}
      </Accordion>
    </CardWrapper>
  );
};

export default ArbitratorsInfo;

export const CardWrapper = styled.div`
  background-color: ${COLORS.PRIMARY_WHITE};
  width: 618px;
  padding: 0 44px 30px 19px;
  border-radius: 11px;
  border: solid 0.5px #e4e5ef;
  .heading {
    width: 100%;
  }
`;

const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0px;
`;

export const CardHeader = styled.h2`
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
`;

const WrapperButton = styled.div`
  width: 146px;
  margin-right: 15px;
`;

export const DeleteButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #ffe8e8;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    background-color: #d91b1b;
    transform: scale(1.05);

    & div {
      color: white;
    }
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DeleteIcon = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #d91b1b;
  transition: color 0.3s ease;
`;
